<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Add integration partner"></aw-bread-crumb>

  <aw-dialog
    [visible]="openIntegrationInfoDialog"
    [formFieldsData]="formFieldsData"
    [dialogOptions]="dialogOptions"
    (primaryAction)="dialogCloseHandler()"
    ariaLabel=""
  >
  </aw-dialog>

  <aw-toast></aw-toast>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'New Integration Partner'"
    [altColor]="false"
  >
  </aw-divider>

  <div class="form-container">
    <!-- Integration Name Field -->
    <app-aw-text-form
      class="input"
      [disable]="false"
      [readOnly]="false"
      [required]="true"
      title="Integration Name"
      (textEntry)="onIntegrationNameSelected($event)"
    ></app-aw-text-form>

    <!-- Integration Status Field -->
    <app-aw-dropdown-form
      class="input"
      [options]="statusOptions()"
      title="Status"
      (currentOption)="onIntegrationStatusSelected($event)"
    ></app-aw-dropdown-form>
  </div>
  <div class="api-auth-details-container">
    <aw-divider
      [inset]="false"
      [middleInset]="false"
      [subTitle]="'API Authentication'"
      [altColor]="true"
    >
    </aw-divider>

    <app-aw-dropdown-form
      class="singular-input"
      [options]="apiAuthTypeOptions()"
      title="Authentication Type"
      (currentOption)="onIntegrationAuthTypeSelected($event)"
    ></app-aw-dropdown-form>

    @if (apiAuthTypeInput) {
    <app-aw-auth-form
      [authType]="apiAuthTypeValue"
      [values]="apiAuthValues"
      [authenticationVersion]="'api'"
      (valuesChangedEvent)="onApiAuthValuesChanged($event)"
    ></app-aw-auth-form>
    }
  </div>

  <div class="employee-auth-details-container">
    <aw-divider
      [inset]="false"
      [middleInset]="false"
      [subTitle]="'Employee Authentication'"
      [altColor]="true"
    >
    </aw-divider>

    <app-aw-dropdown-form
      class="singular-input"
      [options]="employeeAuthTypeOptions()"
      title="Authentication Type"
      [label]="employeeAuthTypeInput"
      [required]="false"
      (currentOption)="onEmployeeAuthTypeSelected($event)"
    ></app-aw-dropdown-form>

    @if (employeeAuthTypeInput) {
    <app-aw-auth-form
      [authType]="employeeAuthTypeValue"
      [values]="employeeAuthValues"
      [editMode]="true"
      [authenticationVersion]="'employee'"
      (valuesChangedEvent)="onEmployeeAuthValuesChanged($event)"
    ></app-aw-auth-form>
    }
  </div>
</div>
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"></aw-action-bar>
</div>
